var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResendDark = function SvgResendDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.226 0v16h3.702v-5.623h1.999L11.095 16h4.433l-3.581-6.172a5.1 5.1 0 0 0 2.21-2.01q.709-1.21.708-2.72 0-1.463-.708-2.607A4.95 4.95 0 0 0 12.191.663Q10.958 0 9.426 0zm3.702 3.247h2.813q.732 0 1.234.25.524.252.8.732.274.457.274 1.074T10.797 6.4q-.228.48-.686.753-.434.253-1.028.254H5.928z"
  })));
};
export default SvgResendDark;